import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { applyCachedTheme } from './lib/theme';
import './styles.css';

// Apply the cached theme before the first render so a returning visitor never
// sees the fallback palette flash to the real one.
applyCachedTheme();

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
